import { Skeleton } from "@/components/ui/skeleton";

// Mirrors CollabDealView: role overline + address headline + meta pill row on
// the left, the bordered "Your progress" widget on the right, then the task and
// document panels below.
export default function CollabDealSkeleton() {
  return (
    <div className="w-full min-w-0" role="status" aria-label="Loading deal">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <Skeleton className="h-3 w-44" />
          <Skeleton className="h-8 w-4/5 max-w-lg" />
          <div className="flex flex-wrap items-center gap-3">
            <Skeleton className="h-5 w-20 rounded-full" />
            <Skeleton className="h-4 w-56 max-w-full" />
          </div>
        </div>

        <div className="flex w-full shrink-0 items-center gap-5 rounded-2xl border border-dash-border bg-white p-4 lg:w-fit">
          <div className="flex flex-col gap-1.5">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-4 w-20" />
          </div>
          <Skeleton className="size-12 shrink-0 rounded-full" />
        </div>
      </div>

      <div className="mt-6 grid gap-4 lg:grid-cols-3">
        <div className="rounded-xl border border-dash-border bg-white p-6 lg:col-span-2">
          <Skeleton className="h-5 w-32" />
          {[0, 1, 2, 3].map((row) => (
            <div key={row} className="mt-5 flex items-center gap-4">
              <Skeleton className="size-5 shrink-0 rounded-full" />
              <div className="min-w-0 flex-1 space-y-2">
                <Skeleton className="h-4 w-3/5" />
                <Skeleton className="h-3 w-2/5" />
              </div>
              <Skeleton className="h-8 w-20 shrink-0" />
            </div>
          ))}
        </div>

        <div className="rounded-xl border border-dash-border bg-white p-6">
          <Skeleton className="h-5 w-28" />
          {[0, 1, 2].map((row) => (
            <div key={row} className="mt-5 flex items-center gap-3">
              <Skeleton className="size-8 shrink-0 rounded" />
              <div className="min-w-0 flex-1 space-y-2">
                <Skeleton className="h-4 w-4/5" />
                <Skeleton className="h-3 w-1/2" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <span className="sr-only">Loading deal…</span>
    </div>
  );
}
